<template>
    <div>
        <tab name="2"></tab>
        <el-alert title="重要提示" type="warning" show-icon :closable="false">
            <div class="message">
                <p>
                    1、这里填写的项目会按顺序在前端优先进行展示，多个ID用英文逗号分隔。
                </p>
                <p>
                    2、置顶的项目如果是已结束或已完成的仍然会被优先展示出来。
                </p>
                <p>
                    3、置顶的项目如果还未通过审核或者是未开始的、已取消的则不会被展示出来。
                </p>
            </div>
        </el-alert>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            v-loading="dataLoading"
            class="MT10"
        >
            <el-form-item prop="ids" label="众筹项目ID:">
                <el-input type="textarea" v-model="formData.ids" :rows="8"></el-input>
            </el-form-item>

            <el-form-item>
                <!-- <el-button @click="goBack">返回取消</el-button> -->
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
import Tab from './components/tab'
export default {
    components:{Tab},
    data(){
        return{
            formData:{
                ids:''
            },
            rules:{},
            dataLoading: false,
            btnLoading: false,
        }
    },
    created(){
        this.getData();
    },
    methods:{
        // 获取详情
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/raise/top",
                method: "POST",
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1) {
                    this.formData.ids = result;
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            }).finally(() => {
                this.dataLoading = false;
            });
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    let _idsArry = [];
                    let _ids = this.formData.ids.split(',');
                    _ids.map(v => {
                        _idsArry = _idsArry.concat(v.split('，'));
                    })
                    _idsArry = _idsArry.filter(v => v !== "");
    
                    this.$request({
                        url:  "/raise/top/set",
                        method: "POST",
                        data: [..._idsArry],
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                //this.goBack();
                                this.$message.success("提交成功");
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>